import { useLocalStorage, decrypted_key, SkillIDs, seed_is_initalised } from "../../Utils"
import React, { useState, useCallback } from "react"
import XORSHIFT128 from "./RNGLib"
import VendorData from "../../assets/json/parameters/spl__PlazaVendorParam.spl__PlazaVendorParam.json"
import classes from "./SeedLister.module.css"
import { defaultImportData } from "../../DefaultEntries"
import { get_murch_filter_labels } from "../../Utils"
import { useTranslation } from "react-i18next"
import MurchInit from "./Murch/MurchInit"
import ResultInit from "./Murch/ResultInit"
import Control from "./Murch/Control"
import ResultSet from "./Murch/Result"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCheck, faX, faCircle } from "@fortawesome/free-solid-svg-icons"
import Tutorial from "./Murch/Tutorial"

const Murch = props => {
    const [userData, setUserData] = useLocalStorage("importData", defaultImportData)
    const { t } = useTranslation()
    const murch_types = get_murch_filter_labels()

    const to_hex = x => `0x${(x >>> 0).toString(16)}`

    const init_current_seed = () => {
        if (userData.CloudRandomSet === undefined) {
            const rng = new XORSHIFT128(`${decrypted_key()}_Vendor`)
            return rng.get_state()
        }
        const inital_seed = userData.CloudRandomSet.Map["Vendor"]
        return [
            to_hex(inital_seed.Context1),
            to_hex(inital_seed.Context2),
            to_hex(inital_seed.Context3),
            to_hex(inital_seed.Context4),
        ]
    }

    const [currentSeed, setCurrentSeed] = useState(init_current_seed())
    const [currentStartFrame, setCurrentStartFrame] = useState(1)
    const [currentNumberOfFrames, setCurrentNumberOfFrames] = useState(10)
    const [displayResults, setDisplayResults] = useState([])
    const [selectedResultTypes, setSelectedResultTypes] = useState(murch_types)
    const [possibleResults, setPossibleResults] = useState([])

    const initialised = seed_is_initalised(userData, "Vendor")

    const handleResultTypes = e => {
        setSelectedResultTypes(e)
    }

    const checkSeedHandler = (event, idx) => {
        let inputstr = event.target.value.toUpperCase()
        if (inputstr.substring(0, 2) === "0X") {
            inputstr = inputstr.substring(2)
        }
        inputstr = inputstr.replace(/[^0-9A-F]/g, "")
        while (inputstr.length > 0 && inputstr.substring(0, 1) === "0") {
            inputstr = inputstr.slice(1)
        }
        if (inputstr.length === 0) {
            inputstr = "0"
        }
        inputstr = "0x" + inputstr
        inputstr = inputstr.substring(0, 10) // cut off too many characters
        const old_input = [...currentSeed]
        old_input[idx] = inputstr
        setCurrentSeed(old_input)
    }

    const checkStartFrameHandler = event => {
        let inputstr = event.target.value
        inputstr = inputstr.replace(/[^0-9]/g, "")
        while (inputstr.length > 0 && inputstr.substring(0, 1) === "0") {
            inputstr = inputstr.slice(1)
        }
        if (inputstr.length === 0 || inputstr === "0") {
            inputstr = "1"
        }

        inputstr = inputstr.substring(0, 5) // cut off too many characters
        setCurrentStartFrame(inputstr)
    }

    const checkNumberOfFrameHandler = event => {
        let inputstr = event.target.value
        inputstr = inputstr.replace(/[^0-9]/g, "")
        while (inputstr.length > 0 && inputstr.substring(0, 1) === "0") {
            inputstr = inputstr.slice(1)
        }
        if (inputstr.length === 0 || inputstr === "0") {
            inputstr = "1"
        }
        inputstr = inputstr.substring(0, 5) // cut off too many characters
        setCurrentNumberOfFrames(inputstr)
    }

    const updateSeedHandler = (newSeed, storeRes) => {
        setCurrentSeed(newSeed)
        if (storeRes) {
            const original = { ...userData }
            original.CloudRandomSet.Map["Vendor"].Context1 = parseInt(newSeed[0].substring(2), 16)
            original.CloudRandomSet.Map["Vendor"].Context2 = parseInt(newSeed[1].substring(2), 16)
            original.CloudRandomSet.Map["Vendor"].Context3 = parseInt(newSeed[2].substring(2), 16)
            original.CloudRandomSet.Map["Vendor"].Context4 = parseInt(newSeed[3].substring(2), 16)
            setUserData(original)
        }
    }

    const get_res = rng_res => {
        const OrderRate = VendorData.OrderSameRate
        const VendorInfo = [
            OrderRate[0].X,
            OrderRate[0].Y,
            OrderRate[1].X,
            OrderRate[1].Y,
            OrderRate[2].X,
            OrderRate[2].Y,
            OrderRate[3].X,
            OrderRate[3].Y,
        ]
        let val = 0.0
        let i = -1
        while (val <= rng_res) {
            i += 1
            val += VendorInfo[i]
        }
        return i
    }

    const evaluate_result = rng => {
        const res = get_res(rng.get_rand_float(0.0, 100.0))
        const main_ability = (res & 1) === 1
        const sub_abilities = res >>> 1
        return [main_ability, sub_abilities]
    }

    const format_result = entry => {
        let res = []
        if (entry[0]) {
            res.push(
                <div style={{ color: "green" }} key={0}>
                    <FontAwesomeIcon icon={faCheck} className="fa-fw" />
                </div>
            )
        } else {
            res.push(
                <div style={{ color: "red" }} key={0}>
                    <FontAwesomeIcon icon={faX} className="fa-fw" />
                </div>
            )
        }
        res.push("|")
        if (entry[1] > 0) {
            res.push(
                <div style={{ color: "green" }} key={1}>
                    <FontAwesomeIcon icon={faCheck} className="fa-fw" />
                </div>
            )
        } else {
            res.push(
                <div style={{ color: "gray" }} key={1}>
                    <FontAwesomeIcon icon={faCircle} className="fa-fw" />
                </div>
            )
        }
        if (entry[1] > 1) {
            res.push(
                <div style={{ color: "green" }} key={2}>
                    <FontAwesomeIcon icon={faCheck} className="fa-fw" />
                </div>
            )
        } else {
            res.push(
                <div style={{ color: "gray" }} key={2}>
                    <FontAwesomeIcon icon={faCircle} className="fa-fw" />
                </div>
            )
        }
        if (entry[1] > 2) {
            res.push(
                <div style={{ color: "green" }} key={3}>
                    <FontAwesomeIcon icon={faCheck} className="fa-fw" />
                </div>
            )
        } else {
            res.push(
                <div style={{ color: "gray" }} key={3}>
                    <FontAwesomeIcon icon={faCircle} className="fa-fw" />
                </div>
            )
        }
        return <div className={classes.abilitiyList}>{res}</div>
        //return `${+entry[0]}|${entry[1]}`
    }

    const format_state = state => {
        return (
            <>
                {state[0]} | {state[1]} | {state[2]} | {state[3]}
            </>
        )
    }

    const is_shown = tmp => {
        const v = +tmp[0] | (tmp[1] << 1)
        if (selectedResultTypes.length === 0) return true

        for (const value of selectedResultTypes) {
            if (value.value === v) {
                return true
            }
        }

        return false
    }

    const calculateResultHandler = () => {
        const rng = new XORSHIFT128(currentSeed[0], currentSeed[1], currentSeed[2], currentSeed[3])
        const res = []
        let i = 0
        const startFrame = parseInt(currentStartFrame) - 1
        const maxFrames = parseInt(currentNumberOfFrames)
        for (i = 0; i < startFrame; i++) {
            evaluate_result(rng)
        }
        for (let results = 0, i = 0; results < maxFrames; i++) {
            const tmp = evaluate_result(rng)
            if (is_shown(tmp)) {
                res.push({
                    Idx: startFrame + i + 1,
                    Result: format_result(tmp),
                    Raw: tmp,
                    Seed: format_state(rng.get_state()),
                    RawSeed: rng.get_state(),
                    Update: true,
                })
                results = results + 1
            }
        }
        setDisplayResults(res)
    }

    const seed_fits = (current_state, entries) => {
        for (var entry of entries) {
            const [main, subs] = evaluate_result(current_state)
            if (entry.receivedGear) {
                const original_main = SkillIDs[entry.gearSelected.value.Skill]
                if (
                    (main && entry.ordered.main === entry.received.main) ||
                    (!main && original_main === entry.received.main)
                ) {
                    switch (subs) {
                        case 0:
                            if (
                                entry.received.subs[0] !== 255 ||
                                entry.received.subs[1] !== 255 ||
                                entry.received.subs[2] !== 255
                            ) {
                                return false
                            }
                            break
                        case 1:
                            if (
                                entry.ordered.subs[0] !== entry.received.subs[0] ||
                                entry.received.subs[1] !== 255 ||
                                entry.received.subs[2] !== 255
                            ) {
                                return false
                            }
                            break
                        case 2:
                            if (
                                entry.ordered.subs[0] !== entry.received.subs[0] ||
                                entry.ordered.subs[1] !== entry.received.subs[1] ||
                                entry.received.subs[2] !== 255
                            ) {
                                return false
                            }
                            break
                        case 3:
                            if (
                                entry.ordered.subs[0] !== entry.received.subs[0] ||
                                entry.ordered.subs[1] !== entry.received.subs[1] ||
                                entry.ordered.subs[2] !== entry.received.subs[2]
                            ) {
                                return false
                            }
                            break
                        default:
                            break
                    }
                } else {
                    return false
                }
            }
        }
        return true
    }

    const estimate_dates = useCallback(() => {
        return Math.floor((new Date() - new Date(2022, 8, 1)) / (24 * 3600 * 1000)) + 20
    }, [])

    const find_seed = entries => {
        const initial_seed = new XORSHIFT128(`${decrypted_key()}_${"Vendor"}`)
        const potential_seeds = []
        for (var i = 0; i < estimate_dates(); i++) {
            const current_state = initial_seed.get_clone()
            if (seed_fits(current_state, entries)) {
                potential_seeds.push(current_state.get_clone())
            }
            initial_seed.get_u32()
        }
        setPossibleResults(potential_seeds)
    }

    const store_seed_from_finding = () => {
        if (possibleResults.length === 1) {
            const original = { ...userData }
            const newSeed = possibleResults[0].get_raw_state()
            original.CloudRandomSet.Map["Vendor"].Context1 = newSeed[0]
            original.CloudRandomSet.Map["Vendor"].Context2 = newSeed[1]
            original.CloudRandomSet.Map["Vendor"].Context3 = newSeed[2]
            original.CloudRandomSet.Map["Vendor"].Context4 = newSeed[3]
            setUserData(original)
            setCurrentSeed(possibleResults[0].get_state())
        }
    }

    const resetSeed = useCallback(() => {
        if (!window.confirm(t("misc:Common.DeleteConfirmation"))) return

        const original = { ...userData }
        original.CloudRandomSet.Map["Vendor"].Context1 = 0
        original.CloudRandomSet.Map["Vendor"].Context2 = 0
        original.CloudRandomSet.Map["Vendor"].Context3 = 0
        original.CloudRandomSet.Map["Vendor"].Context4 = 0
        setUserData(original)
    }, [userData, t, setUserData])

    if (!initialised) {
        return (
            <>
                <Tutorial />
                <MurchInit findSeed={find_seed} />
                <ResultInit possibleResults={possibleResults} storeRes={store_seed_from_finding} />
            </>
        )
    }

    return (
        <>
            <Control
                seedValidator={checkSeedHandler}
                currentSeed={currentSeed}
                currentStartFrame={currentStartFrame}
                currentNumberOfFrames={currentNumberOfFrames}
                startValidator={checkStartFrameHandler}
                numberValidator={checkNumberOfFrameHandler}
                calculateResults={calculateResultHandler}
                handleResultTypes={handleResultTypes}
                selectedResultTypes={selectedResultTypes}
                resetSeed={resetSeed}
            />

            <ResultSet results={displayResults} updateSeed={updateSeedHandler} />
        </>
    )
}

export default Murch
